import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ClientDetailScoreCard.css';

const ClientDetailScoreCard = ({ icon, iconBgColor, title, description, currentScore, maxScore, statusBadges, alertIcon, progressColor }) => {
  const percentage = maxScore ? Math.round((currentScore / maxScore) * 100) : 0;

  return (
    <div className="client-detail-score-card">
      <div className="detail-card-header">
        <div className="detail-card-icon-container" style={{ backgroundColor: iconBgColor }}>
          <FontAwesomeIcon icon={icon} className="detail-card-icon" />
        </div>
        <div className="detail-card-title-description">
          <div className="detail-card-title">{title}</div>
          <div className="detail-card-description">{description}</div>
        </div>
        {alertIcon && <FontAwesomeIcon icon={alertIcon} className="detail-card-alert-icon" />}
      </div>
      
      <div className="data-completeness">
        <span>Data Completeness</span>
        <span className="completeness-score">{currentScore}/{maxScore} ({percentage}%)</span>
      </div>

      <div className="progress-bar-container">
        <div className="progress-bar" style={{ width: `${percentage}%`, backgroundColor: progressColor }}></div>
      </div>

      <div className="status-badges-container">
        {statusBadges && statusBadges.map((badge, index) => (
          <span key={index} className={`detail-status-badge badge-${badge.type}`}>{badge.text}</span>
        ))}
      </div>
    </div>
  );
};

export default ClientDetailScoreCard;
